import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import ListGroups from "./ListGroups";

class Group extends React.Component {
  constructor(props) {
    super(props);
    this.header = [...(props.parentBread || []), "Groups"];
  }

  render() {
    const { serviceProviderRecord, onParentActionClick, parentBread } =
      this.props;
    return (
      <ListGroups
        serviceProviderRecord={serviceProviderRecord}
        onParentActionClick={onParentActionClick}
        parentBread={parentBread}
      />
    );
  }
}

Group.propTypes = {
  serviceProviderRecord: PropTypes.object,
  onParentActionClick: PropTypes.func,
  parentBread: PropTypes.array,

  groupApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  groupApi: state.apis.groupApi,
});
const connectedGroup = connect(mapStateToProps)(Group);
export default withRouter(connectedGroup);
